"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/// <reference types="jquery"/>
var vue_1 = __importDefault(require("vue"));
var TextInput_vue_1 = __importDefault(require("../Input/TextInput.vue"));
var TextOutput_vue_1 = __importDefault(require("../Output/TextOutput.vue"));
var HiddenInput_vue_1 = __importDefault(require("../Input/HiddenInput.vue"));
var TextMultiline_vue_1 = __importDefault(require("../Input/TextMultiline.vue"));
var Number_vue_1 = __importDefault(require("../Input/Number.vue"));
var UploadFile_vue_1 = __importDefault(require("../Input/UploadFile.vue"));
var RadioButton_vue_1 = __importDefault(require("../Input/RadioButton.vue"));
var DatepickerDate_vue_1 = __importDefault(require("../Input/DatepickerDate.vue"));
var SelectCustom_vue_1 = __importDefault(require("../Input/SelectCustom.vue"));
var Row_vue_1 = __importDefault(require("../Layout/Row.vue"));
var Column_vue_1 = __importDefault(require("../Layout/Column.vue"));
var Action_vue_1 = __importDefault(require("../Action/Action.vue"));
var ControlIteration_1 = __importDefault(require("../../Mixins/ControlIteration"));
exports.default = vue_1.default.extend({
    props: ["name", "index", "datas"],
    mixins: [ControlIteration_1.default],
    components: { TextInput: TextInput_vue_1.default, TextOutput: TextOutput_vue_1.default, HiddenInput: HiddenInput_vue_1.default, NumberInput: Number_vue_1.default, UploadFile: UploadFile_vue_1.default, HeRow: Row_vue_1.default, HeColumn: Column_vue_1.default, RadioButton: RadioButton_vue_1.default, DatepickerDate: DatepickerDate_vue_1.default, Action: Action_vue_1.default, TextMultiline: TextMultiline_vue_1.default, SelectCustom: SelectCustom_vue_1.default },
    data: function () {
        var data = !this.datas || this.datas === {} ? "" : this.datas;
        return {
            affaireId: this.$root.$data.affaireId || "",
            type: data.type || "",
            puissance: data.puissance || "",
            tpc: data.tpc !== undefined ? data.tpc : "",
            numPoste: data.numPoste || "",
            nomPoste: data.nomPoste || "",
            numGestionEntreprise: data.numGestionEntreprise || "",
            besoinId: data.besoinId || "",
            marque: data.marque || "",
            numSerie: data.numeroSerie || "",
            anneeFabrication: data.anneeFabrication || "",
            dateEntree: data.dateEntree || "",
            masseTotale: data.masseTotale || "",
            masseDielectrique: data.masseDielectrique || "",
            masseSolide: data.masseSolide || "",
            etiquetteVerte: data.etiquetteVerte !== undefined ? data.etiquetteVerte : "",
            commentaire: data.commentaire || "",
            plaqueSignalitique: data.plaqueSignalitique || [],
            etatGeneral: data.etatGeneral || [],
            done: data.done || "",
            internalReadOnly: this.$root.$data.readOnly || false
        };
    },
    methods: {
        updateMasseSolide: function () {
            var mtotale = this.$refs.mtotale.value, mdielec = this.$refs.mdielec.value;
            this.$refs.msolide.value = !isNaN(mdielec) && !isNaN(mtotale) ? mtotale - mdielec : "";
        },
        setDoneValue: function () {
            this.$refs.done.value = true;
        }
    },
    mounted: function () {
        var _this = this;
        this.$watch(function () { return _this.$refs.mtotale.value; }, function () { _this.updateMasseSolide(); });
        this.$watch(function () { return _this.$refs.mdielec.value; }, function () { _this.updateMasseSolide(); });
    },
    computed: {
        typeOptions: function () {
            return [
                {
                    id: "Cabine",
                    text: "Cabine"
                },
                {
                    id: "H61",
                    text: "H61"
                },
                {
                    id: "PRCS",
                    text: "PRCS"
                },
                {
                    id: "PUIE",
                    text: "PUIE"
                },
                {
                    id: "Poste socle",
                    text: "Poste socle"
                },
            ];
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0&bustCache!./_wwwsrc/js/Workflow/Components/SpecificComponents/DeposeTransformateur.vue
// module id = 208
// module chunks = 0